'use strict';

export default function initHamburgerMenu() {
	const menuToggle = document.querySelector('button.header__menu-toggle');
	const nav = document.querySelector('.header__menu');
	const body = document.querySelector('body');
	const menuItemsWithChildren = document.querySelectorAll('.menu-item-has-children');

	// Mobile menu search elements
	const menuSearchContainer = document.querySelector('.header__menu-search');
	const menuSearchInput = menuSearchContainer ? menuSearchContainer.querySelector('.search-form__input') : null;

	if (!menuToggle || !nav) return;

	menuToggle.addEventListener('click', function() {
		// Toggle active classes
		menuToggle.classList.toggle('active');
		nav.classList.toggle('active');
		body.classList.toggle('menu-open');

		// Update aria-label for screen readers (Åpne meny / Lukk meny)
		menuToggle.setAttribute('aria-label', nav.classList.contains('active') ? 'Lukk meny' : 'Åpne meny');

		// Prevent body scroll when menu is open
		if (nav.classList.contains('active')) {
			body.style.overflow = 'hidden';
		} else {
			body.style.overflow = '';
			// Close all submenus when closing the menu
			menuItemsWithChildren.forEach(item => item.classList.remove('submenu-open'));
			// Close mobile search
			if (menuSearchContainer) {
				menuSearchContainer.classList.remove('active');
				if (menuSearchInput) {
					menuSearchInput.value = '';
				}
			}
		}
	});

	// Handle submenu toggle on all screen sizes
	menuItemsWithChildren.forEach(function(item) {
		const link = item.querySelector(':scope > a');
		if (link) {
			// Create a toggle button for the submenu (for mobile)
			const toggleBtn = document.createElement('button');
			toggleBtn.className = 'submenu-toggle';
			toggleBtn.setAttribute('aria-label', 'Åpne undermeny');
			toggleBtn.innerHTML = '<span class="submenu-toggle__icon"></span>';

			// Insert toggle button after the link
			link.parentNode.insertBefore(toggleBtn, link.nextSibling);

			// Prevent link click and toggle submenu instead
			link.addEventListener('click', function(e) {
				e.preventDefault();
				item.classList.toggle('submenu-open');
			});

			// Toggle submenu when clicking the button (mobile)
			toggleBtn.addEventListener('click', function(e) {
				e.preventDefault();
				e.stopPropagation();
				item.classList.toggle('submenu-open');
				toggleBtn.setAttribute('aria-label',
					item.classList.contains('submenu-open') ? 'Lukk undermeny' : 'Åpne undermeny'
				);
			});
		}
	});

	// Close menu when clicking outside
	document.addEventListener('click', function(event) {
		if (!menuToggle.contains(event.target) && !nav.contains(event.target)) {
			menuToggle.classList.remove('active');
			nav.classList.remove('active');
			body.classList.remove('menu-open');
			menuToggle.setAttribute('aria-label', 'Åpne meny');
			body.style.overflow = '';
			menuItemsWithChildren.forEach(item => item.classList.remove('submenu-open'));
		}

		// Close submenus when clicking outside of them (on desktop)
		menuItemsWithChildren.forEach(function(item) {
			if (!item.contains(event.target)) {
				item.classList.remove('submenu-open');
			}
		});
	});

	// Close menu on escape key
	document.addEventListener('keydown', function(event) {
		if (event.key === 'Escape' && nav.classList.contains('active')) {
			menuToggle.classList.remove('active');
			nav.classList.remove('active');
			body.classList.remove('menu-open');
			menuToggle.setAttribute('aria-label', 'Åpne meny');
			body.style.overflow = '';
			menuItemsWithChildren.forEach(item => item.classList.remove('submenu-open'));
		}
	});
}
